export const services = [
  {
    id: "interior",
    title: "Interior Painting",
    subtitle: "Transform your living spaces",
    description:
      "Professional interior painting with meticulous prep work, premium paints, and flawless finishes. We handle everything from single rooms to entire homes.",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/8bed64e1-3137-4f32-92dc-d20bd8ff6dcd_compressed_interior3.webp",
  },
  {
    id: "exterior",
    title: "Exterior Painting",
    subtitle: "Boost curb appeal",
    description:
      "Weather-resistant exterior painting that protects and beautifies your home or business. We use durable coatings built to withstand Southern California's sun.",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/64de3995-2223-43d3-8412-4d76dc5b1cdf_compressed_exterior2.webp",
  },
  {
    id: "residential",
    title: "Residential",
    subtitle: "Homes & apartments",
    description:
      "Complete residential painting solutions tailored to homeowners, landlords, and property managers. From touch-ups to full makeovers.",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/3f275523-7135-449c-afd1-3aff0fd8d433_compressed_interior9.webp",
  },
  {
    id: "commercial",
    title: "Commercial",
    subtitle: "Offices & businesses",
    description:
      "Minimize downtime with our efficient commercial painting crews. We work around your schedule to deliver professional results for offices, retail, and industrial spaces.",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/e09ad5fe-f034-45e9-9b08-fe899be2c025_compressed_commercial4.webp",
  },
  {
    id: "repairs",
    title: "Wood & Stucco Repairs",
    subtitle: "Restore before painting",
    description:
      "Expert repair of damaged wood and stucco surfaces before painting. We fix cracks, holes, and rot to ensure a perfect, lasting finish.",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/60623993-049b-4830-b68b-0a949f584142_compressed_repair3.webp",
  },
  {
    id: "pressure",
    title: "Pressure Washing",
    subtitle: "Clean surfaces first",
    description:
      "High-pressure washing services to remove dirt, grime, and mildew before painting. Essential for ensuring proper paint adhesion and longevity.",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/438ccc11-c3b6-49c0-aa47-f354d902f628_compressed_washer.webp",
  },
];